import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";

const publicUrl = 'https://pub-796e62f6a8694829b74ff337800a1dcd.r2.dev';
// Simple unauthorized page
function InvalidAuthPage() {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
        <div>
					<img src={publicUrl+"/Desexing_Email_Banner_600x250_v2.png"} style={{width: '600px',marginBottom: '20px'}} />
				</div>
      <h1>Access Denied</h1>
      <div>
                     
                      <p>You are not authorised to view this website.  Please contact your Manager or email <a href="mailto:snipnchip@spca.nz">snipnchip@spca.nz</a>  if you think you should be able to access this site.</p>
                    </div>
    </div>
  );
}

export function RequireOutreachGroup({ groupId, children }) {
  const { accounts } = useMsal();
  const account = accounts[0] || {};
  const groups = (account.idTokenClaims && account.idTokenClaims.groups) || [];

  // null = still checking, true = allowed, false = not allowed
  const [isAllowed, setIsAllowed] = useState(null);

  useEffect(() => {
    setIsAllowed(groups.includes(groupId));
  }, [groups, groupId]);

  if (isAllowed === null) {
    // still verifying membership
    return <p>Verifying permissions…</p>;
  }

  if (!isAllowed) {
    // user is signed in, but not in the outreach group
    return <InvalidAuthPage />;
  }

  // user is in the group
  return <>{children}</>;
}
